import { ServerSideRowModelModule } from "ag-grid-enterprise";
import { ModuleRegistry } from '@ag-grid-community/core';
import { observer } from "mobx-react";
import useStore from "../../../../store";
import { ServerGridConfig } from "../../../../config/GridConfig";
import { AgGridReact } from 'ag-grid-react';
import Message from '../../../../config/Message';
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

const ListComponent = observer(() => {
	ModuleRegistry.registerModules([ServerSideRowModelModule]);
	dayjs.extend(utc);
	dayjs.extend(timezone);

	const { PAYMENT } = useStore();

	const colDefs = [
		{
			headerName: 'Booking No',
			field: 'bookingUniqueNo',
			minWidth: 170,
		},
		{
			headerName: 'Booking Date',
			field: 'bookingDate',
			minWidth: 170,
			sort: 'desc',
			valueFormatter: ({ value }) => {
				return value
				? dayjs.utc(value).tz('Asia/Kolkata').format('DD/MM/YYYY hh:mm A'): '';
			},
		},
		{
			headerName: 'Property Name',
			field: 'propertyName',
			minWidth: 140,
		},
		{
			headerName: 'Guest Name',
			field: 'guestName',
			minWidth: 140,
		},
		{
			headerName: 'Mobile NO',
			field: 'guestMobileNo',
			minWidth: 110,
		},
		{
			headerName: 'Guest Email',
			field: 'guestEmail',
			minWidth: 140,
		},
		{
			headerName: 'Guest State',
			field: 'guestState',
			minWidth: 100,
		},
		{
			headerName: 'Payment Amount',
			field: 'paymentAmount',
			minWidth: 150,
		},
		{
			headerName: 'Payment ID',
			field: 'gatewayPaymentId',
			minWidth: 120,
		},
		{
			headerName: 'Payment Status',
			field: 'paymentStatus',
			minWidth: 80,
		},
		{
			headerName: 'Settlement Status',
			headerTooltip: 'Settlement Status',
			field: 'settlementStatus',
			minWidth: 80
		}
	];
	return (
		<div
			className="ag-theme-quartz"
			style={{ height: 'calc(100vh - 160px)' }}
		>
			<AgGridReact
				onGridReady={PAYMENT.setupGrid}
				headerHeight={35}
				columnDefs={colDefs}
				defaultColDef={ServerGridConfig.defaultColDef}
				columnTypes={ServerGridConfig.columnTypes}
				overlayNoRowsTemplate={Message().noRecord}
				gridOptions={ServerGridConfig.options}
			/>
		</div>
	);
});

export default ListComponent;
